module.exports = __webpack_public_path__ + "img/puerto-rico.212232ee.png";